import {Component, Input} from '@angular/core';
import {CartService} from '../../services/cart/cart.service';
import {UtilService} from '../../services/util/util.service';

@Component({
  selector: 'app-booking-footer',
  templateUrl: './booking-footer.component.html',
  styleUrls: ['./booking-footer.component.scss']
})
export class BookingFooterComponent {
  @Input() public isStandalone: boolean;

  constructor(public cartService: CartService,
              public utilService: UtilService) {}

}
